// feeSummaries.js

const feeSummaries = [
  {
    challanNumber: 'CH1001',
    amount: 120000,
    semester: 1,
    feeType: 'Tuition',
    paidAmount: 120000,
    paidDate: '2022-02-20',
    fine: 0,
  },
  {
    challanNumber: 'CH1002',
    amount: 130000,
    semester: 2,
    feeType: 'Tuition',
    paidAmount: 130000,
    paidDate: '2022-08-25',
    fine: 0,
  },
  {
    challanNumber: 'CH1003',
    amount: 140000,
    semester: 3,
    feeType: 'Tuition',
    paidAmount: 140000,
    paidDate: '2023-02-18',
    fine: 1000,
  },
  {
    challanNumber: 'CH1004',
    amount: 150000,
    semester: 4,
    feeType: 'Tuition',
    paidAmount: 150000,
    paidDate: '2023-08-25',
    fine: 500,
  },
];

export default feeSummaries;
